__turbopack_context__.v({
  "content": "_3souLa_content",
  "drawerOpen": "_3souLa_drawerOpen",
});
